"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaLancamentoCusto = exports.yupLancamentoCusto = exports.schemaCentroCustoLancamento = exports.yupCentroCustoLancamento = void 0;
const yup = __importStar(require("yup"));
exports.yupCentroCustoLancamento = yup.object({
    idCentroCusto: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Centro de Custo'),
    idMensalidade: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('idMensalidade'),
    idContaPagar: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('idContaPagar'),
    valorPrevisto: yup.number().notRequired().label('Valor para Debito'),
    valorRealizado: yup.number().notRequired().label('Valor para Credito'),
    percentual: yup.number().notRequired().label('Valor Percentual'),
});
exports.schemaCentroCustoLancamento = exports.yupCentroCustoLancamento.shape({});
exports.yupLancamentoCusto = yup.object({
    tipoMovimento: yup
        .string()
        .required()
        .oneOf(['RECEBIMENTO', 'PAGAMENTO'], 'O campo deve ser Recebimento ou Pagamento')
        .default('RECEBIMENTO')
        .label('Identificação do movimento: Recebimento ou Pagamento'),
    idMovimento: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .label('idMensalidade ou IdContaPagar'),
    operador: yup
        .string()
        .notRequired()
        .oneOf(['+', '-'], 'O campo deve ser [ + ] --> Recebimento/Pagamento  [ - ] --> Estorno Recebimento/Pagamento')
        .default('+')
        .label(' [ + ] --> Operador Recebimento/Pagamento  [ - ] --> Operador Estorno do Recebimento/Pagamento'),
    valorMovimento: yup.number().notRequired().label('Valor Movimento'),
});
exports.schemaLancamentoCusto = exports.yupLancamentoCusto.shape({});
